import React, { FC } from 'react';

import { Box, DialogContent, Modal, Typography } from '@material-ui/core';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import CloseIcon from '../../../assets/icons/CloseIcon';
import { CustomButton } from '../../UI/CustomButton';
import useStyles from './styles';

interface IConfirmModal {
  onClose: () => void;
  onSubmit: () => void;
  isOpen: boolean;
  title: string;
  description?: string;
  cancelBtnCaption?: string;
  submitBtnCaption?: string;
}

const ConfirmModal: FC<IConfirmModal> = ({
  onClose,
  onSubmit,
  isOpen,
  title,
  description,
  cancelBtnCaption,
  submitBtnCaption,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Modal open={isOpen}>
      <DialogContent className={classes.dialog}>
        <div className={classes.container}>
          <Box className={classes.modal}>
            <CloseIcon className={classes.modalCloseBtn} onClick={onClose} />
            <Typography variant="h3">{title}</Typography>
            {description && (
              <Typography className={classes.modalDescription}>{description}</Typography>
            )}
            <Box className={classes.buttons}>
              <CustomButton
                btnClass={cn(classes.cancelBtn, 'cancel-btn')}
                onClick={onClose}
                color="secondary"
              >
                {cancelBtnCaption || t('button.cancel')}
              </CustomButton>
              <CustomButton data-testid="submitConfirm" btnClass="confirm-btn" onClick={onSubmit}>
                {submitBtnCaption || t('button.delete')}
              </CustomButton>
            </Box>
          </Box>
        </div>
      </DialogContent>
    </Modal>
  );
};

export default ConfirmModal;
